<template>
  <div id="crew-operator-navigation">
    <div class="flex w-full justify-end items-center">
      <div
        class="flex justify-end items-center"
        :style="{
          'min-width': '180px',
        }"
      >
        <div class="button-inner">
          <div
            class="w-full h-12 p-6 flex justify-center items-center cursor-pointer"
            style="border-radius: 6px; height: 44px;"
            :style="{ 'background-color': AISEA_COLOR.BLUE }"
            @click="linkTo('enterprise-management-vessel-dashboard')"
          >
            <span
              class="material-icons-outlined"
              :style="{ color: AISEA_COLOR.WHITE, 'font-size': '16px' }"
            >
              fact_check
            </span>
            <div class="ml-2 aisea-text-16-400-white">ダッシュボード</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      breadcrumbRightPosition: 0,
      crewSettingNavigationBlockHeight: 0,
    };
  },
  computed: {
    isCrewDashboardNavigationHidden() {
      return this.$route.meta.isCrewDashboardNavigationHidden;
    },
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    routeName() {
      this.setBreadcrumbRightPosition();
    },
    onChangeWindowSize() {
      this.setBreadcrumbRightPosition();
    },
    "$store.state.verticalNavMenuWidth"() {
      setTimeout(() => {
        this.setBreadcrumbRightPosition();
      }, 400);
    },
  },
  methods: {
    linkTo(path, query) {
      this.$router.push({ name: path, query: query }, () => {});
      this.open = false;
      this.$nextTick(() => {
        this.setBreadcrumbRightPosition();
      });
    },

    setBreadcrumbRightPosition() {
      const ulElement = document.querySelector("div.vx-breadcrumb ul");
      if (ulElement) {
        this.breadcrumbRightPosition = Math.floor(
          ulElement.getBoundingClientRect().right
        );
        this.$nextTick(() => {
          const navigationBLockEl = document.getElementById(
            "crew-setting-navigation-block"
          );
          if (navigationBLockEl) {
            const crewSettingNavigationBlockHeight = Math.floor(
              navigationBLockEl.getBoundingClientRect().height
            );
            this.crewSettingNavigationBlockHeight = crewSettingNavigationBlockHeight;
            let routerHeaderClass = document.getElementsByClassName(
              "router-header"
            );
            if (crewSettingNavigationBlockHeight > 60) {
              routerHeaderClass[0].style.marginBottom = "56px";
            } else {
              routerHeaderClass[0].style.marginBottom = "21px";
            }
          }
        });
      }
    },
  },
  mounted() {
    this.setBreadcrumbRightPosition();
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import url("https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0");

#crew-operator-navigation {
  position: relative;
  width: fit-content;
  margin-left: auto;
}
</style>
